import { FC } from "react"
import { TravelersBatchUpdate } from "../../../module/travelers/containers/batchUpdate/index"

export const TravelersBatchUpdatePage: FC = () => <TravelersBatchUpdate />
